export default {"src":"/_next/static/media/BetToMax.632bcac8.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};